import { down } from 'styled-breakpoints';
import styled from 'styled-components';

interface visibleProp {
    visible: boolean | undefined;
}
export const StyledModalAnchor = styled.div<visibleProp>`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1055;
    width: 100%;
    height: 100%;
    outline: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px;

    transition: opacity 0.3s;
    ${({ visible }) =>
        visible ? 'pointer-events: all;' : 'pointer-events: none;'};
    ${({ visible }) => (visible ? 'opacity: 1;' : 'opacity: 0;')};
    ${({ visible }) => (visible ? 'z-index: 1;' : 'z-index: 0;')};
`;
export const StyledBackgroundAnchor = styled.div<visibleProp>`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1055;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: hidden;
    outline: 0;
    background-color: black;

    transition: opacity 0.3s;
    ${({ visible }) =>
        visible ? 'pointer-events: all;' : 'pointer-events: none;'};
    ${({ visible }) => (visible ? 'opacity: 0.5;' : 'opacity: 0;')};
    ${({ visible }) => (visible ? 'z-index: 1;' : 'z-index: 0;')};
`;
export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #f0f0f0;
    border-radius: ${({ theme }) => theme.borderRadius.extraLarge};
    padding: 10px;
    width: 100%;
    max-height: 100%;
    max-width: 500px;
    overflow: hidden;

    .content-title {
        background-color: ${({ theme }) => theme.palette.common.white};
    }
`;
export const MobileButton = styled.a`
    flex-direction: row;
    grid-column-gap: 15px;
    column-gap: 15px;
    max-width: 310px;
    height: 57px;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    border-radius: ${({ theme }) => theme.borderRadius.medium};
    cursor: pointer;
    background-color: #fff;

    transition: 0.3s;
    &:hover {
        transition: 0.3s;
        background-color: rgb(242, 242, 242);
    }
    ${down('lg')} {
        height: auto;
        padding: 6px 10px;
        font-size: 14px;
    }
    ${down('sm')} {
        max-width: 100%;
    }
`;
export const MobileButtonTitle = styled.span`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 20px;
    color: ${({ theme }) => theme.palette.common.black};
    ${down('lg')} {
        font-size: 14px;
    }
`;
export const ModalButton = styled.a`
    flex-direction: row;
    grid-column-gap: 15px;
    column-gap: 15px;
    min-height: 65px;
    font-size: 21px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px;
    cursor: pointer;
    background-color: #fff;
    border-top-left-radius: ${({ theme }) => theme.borderRadius.large};
    border-top-right-radius: ${({ theme }) => theme.borderRadius.large};
    border-bottom: 1.5px solid rgb(242, 242, 242);
    transition: 0.3s;
    .svg-asset > span > svg {
        width: 40px;
        height: 40px;
    }
`;
export const ModalButtonTitle = styled.span`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 20px;
    color: ${({ theme }) => theme.palette.common.black};
    ${down('lg')} {
        font-size: 16px;
    }
`;
export const AnchorsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    border-bottom-left-radius: ${({ theme }) => theme.borderRadius.large};
    border-bottom-right-radius: ${({ theme }) => theme.borderRadius.large};

    & > a:first-child {
        & > button {
            border-top: 0px solid rgb(242, 242, 242);
        }
    }
    & > a:last-child {
        & > button {
            border-bottom-left-radius: ${({ theme }) =>
                theme.borderRadius.large};
            border-bottom-right-radius: ${({ theme }) =>
                theme.borderRadius.large};
        }
    }
`;
export const AnchorButton = styled.button`
    display: flex;
    width: 100%;
    background-color: ${({ theme }) => theme.palette.common.white};
    padding: 15px;
    cursor: pointer;
    color: black;

    border-top: 1.5px solid rgb(242, 242, 242);
    transition: 0.3s;
    &:hover {
        transition: 0.3s;
        background-color: #72b995;
        color: white;
    }
`;
export const AnchorTitle = styled.span`
    display: block;
    width: 100%;
    color: ${({ theme }) => theme.palette.common.black};
    font-size: 16px;
    line-height: 1.6;
    overflow: hidden;
    word-break: keep-all;
    cursor: pointer;
    color: inherit;
    text-align: start;
`;
